import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";

import {
  RegisterReducer,
  verifyTimeReducer,
  resendEmailReducer,
  verifyEmailReducer,
  forgotPasswordReducer,
  allUsersReducer,
  updateAvatarReducer,
  inviteUserReducer,
  loadSettingsReducer,
  createCategoryReducer,
  allCategoriesReducers,
  createProductTypeReducer,
  allProductTypesReducer,
  allAdminReducer,
  verifyTokenReducer,
  allPmmReducer,
  userDetailsReducer,
  allowEditingReducer,
  allInviteReducer,
  allBlockedEmailsReducer,
  allProductMarketsReducer,
  createProductMarktReducer,
  uploadReducer,
  allpendingUsersReducer,
  contactReducer,
} from "./redux/reducers/userReducers";
import { allProductReducer, createProductReducer, multiProductUpdateReducer, deleteProductReducer } from "./redux/reducers/productReducers";
import { allNotificationsReducer, marknotificationsReducer } from "./redux/reducers/notificationsReducers";
import { allReservationsReducer, createReservationReducer, singleReservationReducer } from "./redux/reducers/reservationReducers";
import { allOrdersReducer, chartDataReducer, createOrderReducer, createReportReducer, exportOrdersReducer, orderReportsReducer } from "./redux/reducers/orderReducers";
import { clearConversationReducer, getChatUserReducers, getPrivateConversationsReducer, sendPrivateMessageReducer, singleConversationsReducer } from "./redux/reducers/chatReducers";

/* -------------------- reducers -------------------- */
const reducer = combineReducers({
  register: RegisterReducer,
  verifyTime: verifyTimeReducer,
  resendEmail: resendEmailReducer,
  verifyEmailStore: verifyEmailReducer,
  forgotPassword: forgotPasswordReducer,
  allUsers: allUsersReducer,
  updateavtar: updateAvatarReducer,
  getUsers: allAdminReducer,
  getPMMs: allPmmReducer,
  verifyToken: verifyTokenReducer,
  userDetails: userDetailsReducer,
  allowEditing: allowEditingReducer,
  pendingUsers: allpendingUsersReducer,

  blockedEmails: allBlockedEmailsReducer,

  inviteUser: inviteUserReducer,
  allinvites: allInviteReducer,

  loadSettings: loadSettingsReducer,

  createCategory: createCategoryReducer,
  allCategories: allCategoriesReducers,

  createProductType: createProductTypeReducer,
  allProductTypes: allProductTypesReducer,

  createProductMarket: createProductMarktReducer,
  allProductMarkets: allProductMarketsReducer,


  Product: createProductReducer,
  Products: allProductReducer,
  multiProducts: multiProductUpdateReducer,
  deleteProduct: deleteProductReducer,


  notifications: allNotificationsReducer,
  marknotifications: marknotificationsReducer,


  reservation: createReservationReducer,
  reservations: allReservationsReducer,
  singleReservation: singleReservationReducer,



  order: createOrderReducer,
  orders: allOrdersReducer,
  exportOrders: exportOrdersReducer,



  createReport: createReportReducer,
  orderReports: orderReportsReducer,
  chartData: chartDataReducer,




  chatUsers: getChatUserReducers,
  sendPrivateMessage: sendPrivateMessageReducer,
  conversations: getPrivateConversationsReducer,
  conversation: singleConversationsReducer,
  clearConversation: clearConversationReducer,
  upload:uploadReducer,
  contactUs:contactReducer,

});

const initialState = {};
const middleware = [thunk];

/* -------------------- Redux DevTools setup -------------------- */
const composeEnhancers =
  process.env.NODE_ENV !== "production" &&
    typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

/* -------------------- store -------------------- */
const store = createStore(
  reducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
